import { Block } from 'shared-stuff'

export const columnHeaders: Block[] = [{
  value: 1,
  type: 'info',
  label: 'Basic info'
}, {
  value: 1,
  type: 'info',
  label: 'Drivers License'
}, {
  value: 1,
  type: 'info',
  label: 'Education'
}, {
  value: 1,
  type: 'info',
  label: 'Demographics'
}, {
  value: 1,
  type: 'info',
  label: 'Reading'
}, {
  value: 1,
  type: 'info',
  label: 'Math'
}, {
  value: 1,
  type: 'info',
  label: 'Algebra'
}];


// WEBPACK FOOTER //
// /Users/elliot/code/abc-angular/src/app/views/user/column.headers.ts